import React from "react";
import { observer } from "mobx-react";
import { PhonogramCreateStore } from "../../store";
import { PhonogramCreateForm } from "./PhonogramCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PhonogramCreateProps = {
  phonogramCreateStore: PhonogramCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PhonogramCreate: React.FC<PhonogramCreateProps> = observer(
  ({ phonogramCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={phonogramCreateStore.isSaving} />
        <PhonogramCreateForm
          phonogramCreateStore={phonogramCreateStore}
          trackNameError={phonogramCreateStore.errors.trackName?.message}
          onTrackNameChange={(value: string) => {
            phonogramCreateStore.setTrackNameValue(value);
          }}
          trackName={phonogramCreateStore.entityValues.trackName}
          performersError={phonogramCreateStore.errors.performers?.message}
          onPerformersChange={(value) => {
            phonogramCreateStore.setPerformersValue(value);
          }}
          performersSelectedValues={
            phonogramCreateStore.entityValues.showPerformers
          }
          onPerformersSelected={(value) => {
            phonogramCreateStore.setSelectedPerformers(value);
          }}
          performersOptions={phonogramCreateStore.getPerformersOptions()}
          albumNameError={phonogramCreateStore.errors.albumName?.message}
          onAlbumNameChange={(value: string) => {
            phonogramCreateStore.setAlbumNameValue(value);
          }}
          albumName={phonogramCreateStore.entityValues.albumName}
          publicationYearError={
            phonogramCreateStore.errors.publicationYear?.message
          }
          onPublicationYearChange={(value: number | undefined) => {
            phonogramCreateStore.setPublicationYearValue(value);
          }}
          publicationYear={phonogramCreateStore.entityValues.publicationYear}
          isrcError={phonogramCreateStore.errors.isrc?.message}
          onIsrcChange={(value: string) => {
            phonogramCreateStore.setIsrcValue(value);
          }}
          isrc={phonogramCreateStore.entityValues.isrc}
          originalProducerError={
            phonogramCreateStore.errors.originalProducer?.message
          }
          onOriginalProducerChange={(value: string) => {
            phonogramCreateStore.setOriginalProducerValue(value);
          }}
          originalProducer={phonogramCreateStore.entityValues.originalProducer}
          audioFileOnRestoreFile={(id: string) =>
            phonogramCreateStore.audioFileRestoreFile(id)
          }
          audioFileOnLoadFile={(file: any) =>
            phonogramCreateStore.audioFileUploadFile(file)
          }
          audioFileOnCommitFile={(changes) =>
            phonogramCreateStore.audioFileCommitFile(changes)
          }
          audioFileFiles={phonogramCreateStore.entityValues.__audioFile_files}
          audioFileError={phonogramCreateStore.errors.audioFile?.message}
          mainAudioError={phonogramCreateStore.errors.mainAudio?.message}
          onMainAudioChange={(value: boolean) => {
            phonogramCreateStore.setMainAudioValue(value);
          }}
          mainAudio={phonogramCreateStore.entityValues.mainAudio}
          musicalWorkLinkCreateStore={phonogramCreateStore.linksCreateStore}
          linksVisibleColumns={phonogramCreateStore.linksVisibleColumns}
          linksOnRestore={(id: string) => phonogramCreateStore.linksRestore(id)}
          linksOnCommitChanges={(changes) =>
            phonogramCreateStore.linksCommitChanges(changes)
          }
          linksValidateChanges={(changes) =>
            phonogramCreateStore.linksValidateChanges(changes)
          }
          linksRows={phonogramCreateStore.entityValues.showLinks}
          linksError={phonogramCreateStore.errors.links?.message}
          notesError={phonogramCreateStore.errors.notes?.message}
          onNotesChange={(value: string) => {
            phonogramCreateStore.setNotesValue(value);
          }}
          notes={phonogramCreateStore.entityValues.notes}
          dummyCRUDRestoredObservable={
            phonogramCreateStore.dummyCRUDRestoredObservable
          }
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={phonogramCreateStore.isProcessing}
          onSave={() => phonogramCreateStore.saveNewPhonogram()}
          onCancel={() => phonogramCreateStore.cancelNewPhonogram()}
        />
        <ErrorDialog
          open={phonogramCreateStore.errorDialogOpened}
          title={phonogramCreateStore.errorTitle}
          description={phonogramCreateStore.errorDescription}
          onClose={() => phonogramCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
